import { Injectable, Inject } from '@angular/core';
import { AuthService as AuthSocialService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from './user.model';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private fbLink: string = 'api/v1.0/auth/facebook';
  private wbPhoneLink: string = 'api/v1.0/auth/login_by_phone';
  private wbAuthLink: string = '';
  private wbLink: string = 'api/v1.0/auth/wb';
  private emailLink: string = 'api/v1.0/auth/login_by_email';
  public user: User;
  public error=null;
  public token;
  constructor(private authService: AuthSocialService, private cookieService: CookieService, private http: HttpClient, private router: Router) {
    if (this.isLoggedIn) {
      this.user = JSON.parse(localStorage.getItem('user'));
    }
  }

  get getError() {
    return this.error;
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    const formData = new FormData();
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then(
      (userData) => {
            //this will return user data from facebook. What you need is a user token which you will send it to the server
            formData.append('token', userData.authToken);
            this.sendToApi(formData, this.fbLink);
       }
    );
  }
  signInWithEmail(body) {
    this.sendToApi(body, this.emailLink);
  }
  signInWithWB(body) {
    this.sendToApi(body, this.wbLink);
  }
  getTokenByPhone (body: FormData) {
    let query = this.http.post(environment.api_url + this.wbPhoneLink, body);
    query.subscribe(((res:any)=>{
      this.token = res.token;
    }));
  }
 
  authWBPassport(body:FormData):void {
    this.http.post(environment.api_url + this.wbAuthLink, body)
    .subscribe((res:any)=> {
      console.log(res);
    });
  }

  removeToken () {
    this.token = '';
  }
  getNewAccessToken() {
    return this.http.get(environment.api_url + 'api/v1.0/auth/check', {
      headers: {
        'Authorizated': 'Bearer ' + this.getAccesToken
      },
      observe: 'response'
    })
    .pipe(
      tap((res: any) => {
        console.log(res);
        this.setAccesToken(res.token);
      })
    );
  }
 
  logOut() {
    this.authService.signOut();
    localStorage.removeItem('user');
    this.cookieService.delete('token');
    this.router.navigate(['/']);
  }

  setUser(userData) {
    this.user = userData.user;
    localStorage.setItem('user', JSON.stringify(userData.user));
  }
  
  setAccesToken(userData) {
    this.cookieService.set('token', userData.token);
  }
  setUserStorage(userData) {
    this.setAccesToken(userData);
    this.setUser(userData);
  }
  get getAccesToken() {
    return this.cookieService.get('token');
  }

  sendToApi(data: FormData, providerLink: string) {
    this.http.post<any>(environment.api_url + providerLink,  data )
      .subscribe(
        userResp => {
          if (userResp.error) {
            this.error = userResp.error;
            return;
          }
          this.error = null;
          this.setUserStorage(userResp);
          return this.router.navigate(['profile']);
        }
      );
  }

  get isLoggedIn() {
    return !!localStorage.getItem('user');
  }

  roleMatch(allowedRoles): boolean {
    var isMatch = false;
    var userRoles: string[] = this.user.role;
    allowedRoles.forEach(el => {
      if (userRoles.indexOf(el) > -1) {
        isMatch = true;
        return false;
      }
    })
    return isMatch;
  }
  


}
